import React from "react"
import { DrawerSeeker } from "@ui-seeker/core"
import ReportFormHeader from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Header"
import ReportFormDrawerFooter from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Footer"
import { Grid } from "@mui/material"
import {isReportDrawerOpen} from "Pages/ReportsAlerts/Reports/@signals"


export default function ReportFormDrawer({ components = [], children, ...containerProps }) {
	return <DrawerSeeker
		title={<ReportFormHeader/>}
		isOpen={isReportDrawerOpen.value}
		anchor="right"
		width="100%"
		variant="persistent"
		customFooter={<ReportFormDrawerFooter/>}
	>
		<Grid container spacing={2} {...containerProps}>
			{children}
		</Grid>
	</DrawerSeeker>
}